import React, { useState, useRef } from "react";
import AuthLayout from "./AuthLayout";
import borderBack from "../../../assets/images/arrowlefticon.svg";
import { Link } from "react-router-dom";
import MainButton from "../../shared/Button";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import CommonPhoneInputs from "../../shared/authinput/CommonPhoneInputs";
import {
  PhoneInputsMain,
  CustomLabel,
} from "../../shared/commonstyle/PhoneStyle";
import { isValidPhoneNumber } from "react-phone-number-input";
import { getCountryCallingCode } from "react-phone-number-input";
import { FORGOTPASSWORD } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import { ForgotPasswordvalidation } from "../../../helpers/validations/Auth";
import { Header, Maincontant, FormMain } from "./styles/ForgotPasswordStyle";

const ForgotPassword = () => {
  const defaultCountryCode = "US";
  const PhoneInputFoucs = useRef(null);
  const [PhoneError, SetPhoneError] = useState(false);
  const [IsItEmail, SetIsEmail] = useState(true);
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);

  const handleChange = (value, event, form) => {
    SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }
    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
    const digitCount = value?.replace(/\D/g, "")?.length;
    if (digitCount !== undefined && digitCount === 1) {
      SetIsEmail(true);
      form.setFieldValue("IsEmail", digitCount);
    } else if (value === "" || value === undefined) {
      form.setFieldValue("IsEmail", "");
      SetIsEmail(true);
    }
  };

  const EmailOnChange = (value, form) => {
    form.setFieldValue("IsEmail", value);
    if (/^\d+$/.test(value) && value.length >= 2) {
      SetIsEmail(false);
      const phoneNumberValues = `+${getCountryCallingCode(
        defaultCountryCode
      )}${value}`;
      form.setFieldValue("phoneNumber", phoneNumberValues);
      form.setFieldValue("IsEmail", " ");
    } else {
      SetIsEmail(true);
      form.setFieldValue("phoneNumber", "");
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    const { phoneNumber, IsEmail } = values;
    const isValid = isValidPhoneNumber(phoneNumber);

    if (!isValid && phoneNumber !== "") {
      SetPhoneError(true);
      return;
    }

    const userObj =
      IsEmail !== "" && IsEmail !== null && phoneNumber === ""
        ? { email: IsEmail }
        : { phone_number: phoneNumber };

    try {
      setLoading(true);
      const resp = await httpRequest.post(FORGOTPASSWORD, {
        user: userObj,
      });
      console.log("🚀 ~ file: Login.js:124 ~ handleSubmit ~ resp:", resp);
      if (resp?.status === 200) {
        resetForm();
        toast.success("An email sent to you for verification.");
        const verificationPath =
          IsEmail !== "" && IsEmail !== null && phoneNumber === ""
            ? `/verification?email=${values.IsEmail}`
            : `/verification?phone=${values.phoneNumber}`;

        navigate(verificationPath);
      }
    } catch (error) {
      toast.error(
        (error?.response?.data?.message || "Something went wrong").replace(
          "Validation failed: ",
          ""
        )
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg">
      <AuthLayout arrow={true}>
        <Header>
          <Link to="/login" className="arrows">
            <img src={borderBack} alt="Linkarrow" />
          </Link>
          <Maincontant className="main_contant">
            <h6>Forgot Password </h6>
            <p>
              Provide your phone number for which you want to reset your
              password
            </p>
          </Maincontant>
        </Header>
        <FormMain>
          <Formik
            initialValues={{
              phoneNumber: "",
              IsEmail: "",
            }}
            validationSchema={ForgotPasswordvalidation}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form autocomplete="off">
                {IsItEmail ? (
                  <>
                    <CustomLabel>
                      What's your phone number or email?
                    </CustomLabel>
                    <PhoneInputsMain
                      className={
                        formik.touched.IsEmail &&
                        formik.errors.IsEmail &&
                        "is__error"
                      }
                    >
                      <Field
                        type="email"
                        name="IsEmail"
                        label="What's your phone number or email?"
                        placeholder="Enter phone number or email"
                      >
                        {({ field, form }) => (
                          <input
                            {...field}
                            onChange={(event) =>
                              EmailOnChange(event.target.value, form)
                            }
                            placeholder="Enter phone number or email"
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="IsEmail"
                        component="span"
                        className="error"
                      />
                    </PhoneInputsMain>
                  </>
                ) : (
                  <PhoneInputsMain
                    className={
                      formik.touched.phoneNumber &&
                      formik.errors.phoneNumber &&
                      "is__error"
                    }
                  >
                    <CustomLabel>
                      What's your phone number or email?
                    </CustomLabel>
                    <Field name="phoneNumber">
                      {({ field, form }) => (
                        <CommonPhoneInputs
                          // {...field}

                          onChange={(value, event) =>
                            handleChange(value, event, form)
                          }
                          value={formik.values.phoneNumber}
                          ref={PhoneInputFoucs}
                        />
                      )}
                    </Field>

                    <ErrorMessage
                      name="phoneNumber"
                      component="span"
                      className="error"
                    />
                  </PhoneInputsMain>
                )}

                {PhoneError && (
                  <span className="Phoneerror" style={{ color: "red" }}>
                    Invalid phone number
                  </span>
                )}
                <MainButton
                  type="submit"
                  label="Send"
                  MT="150"
                  isLoading={Loading}
                />
                <MainButton
                  type="button"
                  label="Cancel"
                  border={true}
                  MT="15"
                  onClick={() => navigate("/login")}
                />
              </Form>
            )}
          </Formik>
        </FormMain>
      </AuthLayout>
    </Container>
  );
};

export default ForgotPassword;
